<template>
  <div class="admin-layout">
    <!-- Mobil Ok Butonu -->
    <button class="mobile-sidebar-arrow" @click="sidebarOpen = !sidebarOpen">
      <span v-if="!sidebarOpen">⇨</span>
      <span v-else>⇦</span>
    </button>

    <!-- Sol Panel -->
    <aside :class="['sidebar', { collapsed, show: sidebarOpen }]">
      <nav class="sidebar-menu">
        <ul>
          <li class="menu-toggle" @click="collapsed = !collapsed">
            <span class="icon">☰</span>
          </li>
          <li :class="{ active: page === 'dashboard' }" @click="page = 'dashboard'; sidebarOpen = false">
            <span class="icon">📊</span><span v-if="!collapsed" class="label">Dashboard</span>
          </li>
          <li :class="{ active: page === 'translators' }" @click="page = 'translators'; sidebarOpen = false">
            <span class="icon">👤</span><span v-if="!collapsed" class="label">Tercümanlar</span>
          </li>
          <li :class="{ active: page === 'jobs' }" @click="page = 'jobs'; sidebarOpen = false">
            <span class="icon">📁</span><span v-if="!collapsed" class="label">İşler</span>
          </li>
          <li :class="{ active: page === 'pages' }" @click="page = 'pages'; sidebarOpen = false">
            <span class="icon">🧾</span><span v-if="!collapsed" class="label">Sayfa Yönetimi</span>
          </li>
          <li :class="{ active: page === 'services' }" @click="page = 'services'; sidebarOpen = false">
            <span class="icon">🛠️</span><span v-if="!collapsed" class="label">Hizmetlerimiz</span>
          </li>
          <li :class="{ active: page === 'featuredTranslators' }" @click="page = 'featuredTranslators'; sidebarOpen = false">
            <span class="icon">📝</span><span v-if="!collapsed" class="label">Tercüman Sayfası</span>
          </li>
          <li :class="{ active: page === 'sliders' }" @click="page = 'sliders'; sidebarOpen = false">
            <span class="icon">🖼️</span><span v-if="!collapsed" class="label">Slider Düzenleme</span>
          </li>
          <li :class="{ active: page === 'languages' }" @click="page = 'languages'; sidebarOpen = false">
            <span class="icon">🌐</span><span v-if="!collapsed" class="label">Diller</span>
          </li>
        </ul>
      </nav>
    </aside>

    <!-- Ana İçerik -->
    <main class="main-content background-wrapper">
      <div class="overlay"></div>
      <section class="section content-area">
        <component :is="currentComponent" v-bind="currentProps" />
      </section>
    </main>
  </div>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue'
import { getToken } from '@/utils/auth'


import Dashboard from '../AdminSections/Dashboard.vue'
import Translators from '../AdminSections/Translators.vue'
import Jobs from '../AdminSections/Jobs.vue'
import Pages from '../AdminSections/Pages.vue'
import Languages from '../AdminSections/Languages.vue'
import AdminServices from '../AdminSections/AdminServices.vue'
import AdminSliders from '../AdminSections/AdminSliders.vue'
import FeaturedTranslators from '../AdminSections/FeaturedTranslators.vue'

const baseURL = process.env.VUE_APP_API_URL
const page = ref('dashboard')
const collapsed = ref(false)
const sidebarOpen = ref(false) // mobilde aç-kapa
const stats = ref({})
const jobs = ref([])
const pendingTranslators = ref([])

const currentComponent = computed(() => {
  return {
    dashboard: Dashboard,
    translators: Translators,
    jobs: Jobs,
    pages: Pages,
    languages: Languages,
    services: AdminServices,
    sliders: AdminSliders,
    featuredTranslators: FeaturedTranslators
  }[page.value]
})

const currentProps = computed(() => {
  switch (page.value) {
    case 'dashboard':
      return { stats: stats.value }
    case 'translators':
      return { pendingTranslators: pendingTranslators.value, fetchData }
    case 'jobs':
      return { jobs: jobs.value, fetchData }
    default:
      return {}
  }
})

async function fetchData() {
  const token = getToken()

  const resStats = await fetch(`${baseURL}/admin/stats`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  stats.value = await resStats.json()

  const resTranslators = await fetch(`${baseURL}/admin/translators/pending`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  pendingTranslators.value = await resTranslators.json()

  const resJobs = await fetch(`${baseURL}/admin/jobs`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  jobs.value = await resJobs.json()
}

onMounted(fetchData)
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
}

/* Sidebar */
.sidebar {
  position: sticky;
  top: 60px;
  height: calc(100vh - 60px);
  width: 220px;
  background: rgba(17, 24, 31, 0.523);
  color: #fff;
  transition: width 0.3s ease;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.sidebar.collapsed {
  width: 60px;
  background: rgba(0, 0, 0, 0.393);
  
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.sidebar li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
  white-space: nowrap;
  position: relative;
  color: #f0e8e8;
  justify-content: flex-start;
  padding-left: 16px;
}

.sidebar li .label {
  transition: opacity 0.2s ease;
}

.sidebar.collapsed li {
  justify-content: center;
  padding-left: 0;
  
}

.sidebar.collapsed li .label {
  display: none;
}

.sidebar li:hover,
.sidebar li.active {
  background-color: rgba(178, 77, 30, 0.596);
}

.sidebar li.menu-toggle {
  margin-bottom: 40px;
  justify-content: center;
  color: black;
}

.sidebar li .icon {
  font-size: 18px;
}

/* Ana içerik */
.main-content.background-wrapper {
  flex: 1;
  position: relative;
  
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.356);
  z-index: 1;
}

.content-area {
  position: relative;
  z-index: 2;
  padding: 30px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(4px);
  color: #fff;
}
.mobile-sidebar-arrow {
  display: none;
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  font-size: 28px;
  font-weight: bold;
  padding: 10px 16px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  cursor: pointer;
  z-index: 10000;
}
.section {
  flex-grow: 1;
}
@media (max-width: 768px) {
  .mobile-sidebar-arrow {
    display: block;
  }

  .sidebar {
    position: fixed !important;
    top: 0;
    left: 0;
    height: 100vh !important;
    width: 220px !important;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 9999;
  }
    .sidebar.show {
    transform: translateX(0);
  }

  .sidebar-menu {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 10px;
  }

  .sidebar ul {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }

  .sidebar li {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    min-width: 60px;
    font-size: 12px;
  }

  .sidebar li .icon {
    font-size: 18px;
  }

  .sidebar li .label {
    font-size: 11px;
  }
  .main-content.background-wrapper {
    padding-top: 60px;
  }

  .content-area {
    padding: 16px;
  }

  .section {
    padding: 16px;
  }
  
}

</style>
